import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user
  },
  getters: {
    uid: state => state.user.uid,
    api_url: state => state.user.apiUrl
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js